// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";

// const AddCompetitionSubjectiveExamPricing = () => {
//   const [competitions, setCompetitions] = useState([]);
//   const [competitionsId, setCompetitionsId] = useState();
//   const [price, setPrice] = useState();

//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const handleGoBack = () => {
//     navigate("/subjective-exam-pricing");
//   };
//   const handleAddPrice = () => {
//     navigate(
//       "/subjective-exam-pricing/add-competition-subjective-exam-pricing"
//     );
//   };
//   const handleViewAllPrice = () => {
//     navigate(
//       "/subjective-exam-pricing/all-competition-subjective-exam-pricing"
//     );
//   };

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/competitions`)
//       .then((response) => {
//         const examCategoriesData = response.data?.data || [];
//         setCompetitions(examCategoriesData);
//       })
//       .catch((error) => console.log(error));
//   }, []);

//   const payload = {
//     competitionId: competitionsId,
//     price,
//     type: "competition",
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     axios
//       .post(`${API_BASE_URL}/admin/pricing/subjective-exam`, payload, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((result) => {
//         console.log(result);
//         alert("Price added successfully.");
//       })
//       .catch((error) => {
//         console.log(error);
//         alert("Error while adding price.");
//       });
//   };

//   return (
//     <>
//       <div id="exam-competitive-notes-inner-wrapper">
//         <div className="competitive-main-header">
//           <BiArrowBack
//             onClick={handleGoBack}
//             className="left-arrow-icon"
//             style={{
//               cursor: "pointer",
//               marginLeft: "10px",
//               fontSize: "25px",
//               color: "#000", // Customize the color as needed
//             }}
//           />
//           <div className="competitive-header-div">
//             <h5>Competitive Subjective Exam Pricing</h5>

//             <div className="competitive-btn-group">
//               <button
//                 className="addNewCompetitiveNoteBtn"
//                 onClick={handleAddPrice}
//               >
//                 + Add Price
//               </button>
//               <button
//                 className="viewAllCompetitiveNotesBtn"
//                 onClick={handleViewAllPrice}
//               >
//                 All Price
//               </button>
//             </div>
//           </div>

//           <div className="competitive-form-container" id="form">
//             <h4 className="competitive-note-detail">Add Price</h4>
//             <form
//               onSubmit={handleSubmit}
//               className="competitive-note-detail-form"
//             >
//               <div className="new-chapter-form-group">
//                 <label className="new-chapter-label">Exam Category</label>
//                 <select
//                   className="new-chapter-dropdown"
//                   value={competitionsId}
//                   onChange={(e) => setCompetitionsId(e.target.value)}
//                   required
//                 >
//                   <option value="">-Select Category-</option>
//                   {competitions.map((examCategory, idx) => (
//                     <option key={idx} value={examCategory._id}>
//                       {examCategory.examCategory}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="input-group">
//                 <label className="label">Price</label>
//                 <input
//                   type="text"
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                   placeholder="Enter Price"
//                   required
//                 />
//               </div>

//               <div className="competitive-form-btns">
//                 <button className="competitive-btn-save" type="submit">
//                   Save
//                 </button>
//                 <button
//                   className="competitive-btn-cancel"
//                   type="button"
//                   onClick={() =>
//                     navigate(
//                       "/subjective-exam-pricing/all-competition-subjective-exam-pricing"
//                     )
//                   }
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddCompetitionSubjectiveExamPricing;








import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const API = process.env.REACT_APP_API_BASEURL;

export default function CompetitionSubjectiveExamSubscription() {

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  const defaultPlans = [
    { duration: 1, price: "" },
    { duration: 3, price: "" },
    { duration: 6, price: "" },
    { duration: 12, price: "" }
  ];

  const [competitions, setCompetitions] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [competitionId, setCompetitionId] = useState("");
  const [subjectId, setSubjectId] = useState("");

  const [plans, setPlans] = useState(defaultPlans);
  const [trialEnabled, setTrialEnabled] = useState(true);
  const [trialDays, setTrialDays] = useState(7);

  const [existingPlan, setExistingPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= RESET ================= */

  const resetForm = () => {
    setExistingPlan(null);
    setPlans(defaultPlans);
    setTrialEnabled(true);
    setTrialDays(7);
  };

  /* ================= FETCH COMPETITIONS ================= */

  useEffect(() => {
    axios.get(`${API}/competitions`)
      .then(res => setCompetitions(res.data.data || []))
      .catch(console.log);
  }, []);

  /* ================= FETCH SUBJECTS ================= */

  useEffect(() => {
    if (!competitionId) {
      setSubjects([]);
      resetForm();
      return;
    }

    axios.get(`${API}/subjects`, {
      params: { reference: competitionId }
    })
      .then(res => setSubjects(res.data.data || []))
      .catch(console.log);

  }, [competitionId]);

  /* ================= AUTO FETCH PLAN ================= */

  useEffect(() => {
    if (competitionId && subjectId) {
      fetchPlan();
    }
  }, [competitionId, subjectId]);

  /* ================= FETCH PLAN ================= */

  const fetchPlan = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API}/pricing/subjective-exam`,
        {
          params: { competitionId, subjectId },
          headers
        }
      );

      const data = res.data.data;

      if (!data) {
        resetForm();
        return;
      }

      setExistingPlan(data);
      setPlans(data.subscriptionOptions || defaultPlans);
      setTrialEnabled(data.trialEnabled ?? true);
      setTrialDays(data.trialDays ?? 7);

    } catch {
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  /* ================= HANDLE PRICE ================= */

  const handlePriceChange = (duration, value) => {
    setPlans(prev =>
      prev.map(p =>
        p.duration === duration ? { ...p, price: value } : p
      )
    );
  };

  /* ================= CREATE / UPDATE ================= */

  const handleSubmit = async () => {

    if (!competitionId || !subjectId) {
      Swal.fire("Missing", "Select competition & subject", "warning");
      return;
    }

    try {

      setLoading(true);

      const payload = {
        type: "competition",
        competitionId,
        subjectId,
        subscriptionOptions: plans,
        trialEnabled,
        trialDays
      };

      if (existingPlan) {
        await axios.put(
          `${API}/admin/pricing/subjective-exam/${existingPlan._id}`,
          payload,
          { headers }
        );
        Swal.fire("Updated", "Plan updated successfully", "success");
      } else {
        await axios.post(
          `${API}/admin/pricing/subjective-exam`,
          payload,
          { headers }
        );
        Swal.fire("Created", "Plan created successfully", "success");
      }

      fetchPlan();

    } catch (err) {
      Swal.fire("Error", err.response?.data?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */

  const deletePlan = async () => {

    const confirm = await Swal.fire({
      title: "Delete Plan?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    await axios.delete(
      `${API}/admin/pricing/subjective-exam/${existingPlan._id}`,
      { headers }
    );

    Swal.fire("Deleted", "Plan deleted", "success");
    resetForm();
  };

  return (
    <div className="wrapper">

      <h2 className="heading">
        🏆 Competition Subjective Subscription
      </h2>

      <div className="card">

        <select
          value={competitionId}
          onChange={e => {
            setCompetitionId(e.target.value);
            setSubjectId("");
          }}
          className="input"
        >
          <option value="">Select Competition</option>
          {competitions.map(c => (
            <option key={c._id} value={c._id}>
              {c.examCategory}
            </option>
          ))}
        </select>

        <select
          value={subjectId}
          onChange={e => setSubjectId(e.target.value)}
          className="input"
        >
          <option value="">Select Subject</option>
          {subjects.map(s => (
            <option key={s._id} value={s._id}>
              {s.subjectName}
            </option>
          ))}
        </select>

      </div>

      <div className="card">

        {plans.map(plan => (
          <div key={plan.duration} className="plan-row">
            <span>{plan.duration} Month</span>
            <input
              type="number"
              value={plan.price}
              placeholder="Enter price"
              onChange={e =>
                handlePriceChange(plan.duration, e.target.value)
              }
              className="input"
            />
          </div>
        ))}

        <div className="plan-row">
          <span>Trial Enabled</span>
          <input
            type="checkbox"
            checked={trialEnabled}
            onChange={e => setTrialEnabled(e.target.checked)}
          />
        </div>

        <div className="plan-row">
          <span>Trial Days</span>
          <input
            type="number"
            value={trialDays}
            onChange={e => setTrialDays(e.target.value)}
            className="input"
          />
        </div>

        <button
          onClick={handleSubmit}
          className="btn primary"
          disabled={loading}
        >
          {existingPlan ? "Update Plan" : "Create Plan"}
        </button>

        {existingPlan && (
          <button onClick={deletePlan} className="btn danger">
            Delete Plan
          </button>
        )}

      </div>

      {/* GEN-Z STYLE */}
      <style>{`
        .wrapper{
          max-width:650px;
          margin:50px auto;
          font-family:Inter, sans-serif;
        }

        .heading{
          text-align:center;
          background: linear-gradient(90deg,#6366f1,#ec4899);
          -webkit-background-clip: text;
          color: transparent;
          font-size:28px;
          font-weight:700;
          margin-bottom:25px;
        }

        .card{
          background: rgba(255,255,255,0.7);
          backdrop-filter: blur(12px);
          padding:25px;
          border-radius:18px;
          margin-bottom:20px;
          box-shadow:0 8px 25px rgba(0,0,0,0.05);
        }

        .input{
          width:100%;
          padding:12px;
          border-radius:12px;
          border:1px solid #e5e7eb;
          margin-bottom:12px;
          font-size:14px;
        }

        .plan-row{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-bottom:12px;
        }

        .btn{
          width:100%;
          padding:12px;
          border:none;
          border-radius:14px;
          margin-top:10px;
          cursor:pointer;
          font-weight:600;
          transition:0.3s;
        }

        .primary{
          background:linear-gradient(90deg,#6366f1,#8b5cf6);
          color:white;
        }

        .danger{
          background:#ef4444;
          color:white;
        }

        .btn:hover{
          transform:translateY(-2px);
          box-shadow:0 6px 15px rgba(0,0,0,0.1);
        }
      `}</style>

    </div>
  );
}